module.exports = "/_next/static/images/trust-link-visa-card-738e3d5454a54208f087adacb15e4c42.png";